import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Components
import { ParagraphComponent } from '../paragraph/paragraph.component';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
// Configurations
import { getStepperProgressBarConfig } from './configurations/wizard-stepper.configurations';
// Constants
import { RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
// Hooks
import { WizardStepperHook } from './hooks/wizard-stepper.hook';
// Styles
import { WizardStepperContentComponentWrapperStyled } from './wizard-stepper.component.styled';
// Types
import { WizardStepperVariantsType } from '../../designSystem/reloaded/commons/components/wizard-stepper';
const WizardStepperComponent = ({ variant = WizardStepperVariantsType.DEFAULT, title, textProgress, progressBars, }) => {
    const { styles } = WizardStepperHook({ variant });
    return (_jsxs("div", { children: [_jsxs(WizardStepperContentComponentWrapperStyled, { styles: styles, children: [_jsx(ParagraphComponent, { customTypography: styles?.textProgress, children: textProgress }), _jsx(ParagraphComponent, { customTypography: styles?.title, children: title })] }), _jsx(ProgressBarComponent, { progressBars: { ...progressBars, ...getStepperProgressBarConfig() }, variant: RELOADED_VARIANTS.ProgressBarComplexVariantType.LINEAR_REGULAR })] }));
};
export { WizardStepperComponent };
//# sourceMappingURL=wizard-stepper.component.js.map